"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.anyDecoder = exports.gitlabDecoder = exports.githubDecoder = exports.stateDecoder = void 0;
var ts_data_json_1 = require("ts.data.json");
var ExternalRepoDecoder = __importStar(require("./external-repo"));
var timestamp_1 = __importDefault(require("./timestamp"));
var user_stanza_1 = __importDefault(require("./user-stanza"));
exports.stateDecoder = new ts_data_json_1.JsonDecoder.Decoder(function (value) {
    switch (value) {
        case 'open':
        case 'closed':
            return (0, ts_data_json_1.ok)(value);
        default:
            return (0, ts_data_json_1.err)("Failed to decode ".concat(value, " as pull request state"));
    }
});
var sharedPropsDecoder = ts_data_json_1.JsonDecoder.object({
    pullRequestId: ts_data_json_1.JsonDecoder.number,
    url: ts_data_json_1.JsonDecoder.string,
    branchName: ts_data_json_1.JsonDecoder.string,
    baseBranchName: ts_data_json_1.JsonDecoder.string,
    product: ts_data_json_1.JsonDecoder.string,
    title: ts_data_json_1.JsonDecoder.string,
    description: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.string),
    state: exports.stateDecoder,
    additionsCount: ts_data_json_1.JsonDecoder.number,
    deletionsCount: ts_data_json_1.JsonDecoder.number,
    changedFilesCount: ts_data_json_1.JsonDecoder.number,
    createdAt: timestamp_1.default,
    updatedAt: timestamp_1.default,
    readyForReviewAt: ts_data_json_1.JsonDecoder.nullable(timestamp_1.default),
    user: user_stanza_1.default,
    reviewers: ts_data_json_1.JsonDecoder.array(user_stanza_1.default, 'UserStanza[]'),
    assignees: ts_data_json_1.JsonDecoder.array(user_stanza_1.default, 'UserStanza[]'),
    userIds: ts_data_json_1.JsonDecoder.optional(ts_data_json_1.JsonDecoder.array(ts_data_json_1.JsonDecoder.string, 'UserId[]')),
    commentsCount: ts_data_json_1.JsonDecoder.number,
    mergeableState: ts_data_json_1.JsonDecoder.oneOf([
        ts_data_json_1.JsonDecoder.isExactly('pending'),
        ts_data_json_1.JsonDecoder.isExactly('checks-failed'),
        ts_data_json_1.JsonDecoder.isExactly('blocked'),
        ts_data_json_1.JsonDecoder.isExactly('conflicts'),
        ts_data_json_1.JsonDecoder.isExactly('merge-ready'),
        ts_data_json_1.JsonDecoder.isExactly('merged'),
        ts_data_json_1.JsonDecoder.isExactly('closed'),
    ], 'MergeableState'),
}, 'PullRequestSharedProps');
var githubPropsDecoder = ts_data_json_1.JsonDecoder.object({
    externalService: ExternalRepoDecoder.githubDecoder,
}, 'GithubPropsDecoder');
exports.githubDecoder = ts_data_json_1.JsonDecoder.combine(sharedPropsDecoder, githubPropsDecoder);
var gitlabPropsDecoder = ts_data_json_1.JsonDecoder.object({
    externalService: ExternalRepoDecoder.gitlabDecoder,
}, 'GitlabPropsDecoder');
exports.gitlabDecoder = ts_data_json_1.JsonDecoder.combine(sharedPropsDecoder, gitlabPropsDecoder);
exports.anyDecoder = ts_data_json_1.JsonDecoder.oneOf([exports.githubDecoder, exports.gitlabDecoder], 'PullRequest<ExternalRepo.Any>');
